import React, { useEffect } from 'react'
import Task from '@screens/WorkOrders/list/Task'
import WorkOrder from '@screens/WorkOrders/list/WorkOrder'
import WorkOrderList from '@screens/WorkOrders/list/WorkOrderList'
import PendingWorkOrder from '@screens/WorkOrders/list/PendingWorkOrder'
import { createNativeStackNavigator } from '@react-navigation/native-stack'
import useNavigation from '@hooks/useNavigation'

interface NavigationProps {
  route?: any
}

const Stack = createNativeStackNavigator()

export default function () {
  const navigation = useNavigation()
  useEffect(() => {
    navigation.setOptions({ tabBarStyle: { display: 'none' } })
  }, [])

  const WorkOrderListScreen = WorkOrderList
  const WorkOrderScreen = ({ route }: NavigationProps) => <WorkOrder {...{ route }} />
  const PendingWorkOrderScreen = ({ route }: NavigationProps) => <PendingWorkOrder {...{ route }} />
  const TaskScreen = ({ route }: NavigationProps) => <Task {...{ route }} />

  return (
    <Stack.Navigator
      initialRouteName="workOrderList"
      screenOptions={{ headerShown: false }}
    >
      <Stack.Screen name='workOrderList' component={ WorkOrderListScreen } />
      <Stack.Screen name='workOrderView' component={ WorkOrderScreen } />
      <Stack.Screen name='pendingWorkOrderView' component={ PendingWorkOrderScreen } />
      <Stack.Screen name='task' component={ TaskScreen } />
    </Stack.Navigator>
  )
}
